import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { WhatsAppButton, CallButton } from "@/components/CTAButtons";
import { IMAGES } from "@/data/site";

export default function FinalCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section ref={ref} className="relative overflow-hidden grain" data-testid="final-cta">
      <motion.div style={{ y }} className="absolute inset-0">
        <img src={IMAGES.highwayRescue} alt="Guincho em atendimento na rodovia" loading="lazy" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-black/75" />
      <div className="relative z-10 mx-auto max-w-4xl px-5 py-28 text-center md:px-8 md:py-40">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Precisando de Auto Socorro?</p>
        <h2 className="mt-5 font-display text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl lg:text-8xl">
          Nossa equipe está<br /><span className="text-brand-red">pronta 24 horas</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/70">
          Estamos prontos para atender você a qualquer hora do dia ou da noite, todos os dias da semana.
          Fale conosco agora mesmo.
        </p>
        <div className="mt-9 flex flex-col justify-center gap-4 sm:flex-row">
          <WhatsAppButton testid="finalcta-whatsapp" />
          <CallButton testid="finalcta-call" />
        </div>
      </div>
    </section>
  );
}
